<template>
  <ui-modal
    :show="showNotic"
    type="tag"
    :title="title"
    @close="closeModal()"
  >
    <div class="inner-content">
      <div class="scroll-box">
        {{ $lg(config, 'registration_notic', '') }}
      </div>
    </div>
    <div class="agree-box">
      <button class="btn" @click="handleAgree">
        <span >我已阅读，并同意</span>
      </button>
    </div>
  </ui-modal>
</template>

<script>
import UiModal from "@/components/ui-modal.vue";
import * as api from '@/service/index';
import { mapState } from "vuex";

export default {
  components: { UiModal },
  inject: ['json_config'],
  props: {
    agree: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showNotic: false,
      title: '报名须知',
      agree_before: '我已阅读，并同意（',
      count: 10,
      agree_after: 'S）',
      loading: false
    }
  },
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    },
  },
  methods: {
    showModal() {
      this.showNotic = true;

      
    },
    closeModal() {
      this.showNotic = false;

    },
    handleAgree() {
      this.closeModal();
    }
  }
}
</script>

<style lang="scss" scoped>
.inner-content {
  width: 780px;
  height: 286px;
  margin: 35px auto 26px;
  overflow: hidden;

  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;
  }
}
.agree-box {
  width: 100%;
  background-color: #F4F4F4;
  text-align: center;
  .btn {
    width: 388px;
    height: 58px;
    margin: 20px auto 26px;
    background: #FEE000;
    box-shadow: 0px 2px 0px #E7CB00, 0px -2px 0px #FFF18B;
    border-radius: 10px;
    font-size: 24px;
    color: #000;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &:active {
      opacity: 0.8;
    }
  }
}
</style>